export var restrictedUrlTree = function (router, _a) {
    var _b = _a === void 0 ? {} : _a, code = _b.code, page = _b.page;
    return router.createUrlTree(['/restricted-access'], {
        queryParams: {
            target: page ? page.identifier : '',
            reason: code,
        },
        skipLocationChange: true,
    });
};
